/**
 * Resolve the destination folder id for a drag-and-drop move (kept react-free so it can be
 * unit-tested without a DOM/react test environment — see FileBrowser.tsx for the caller).
 *
 * Drop targets surface `null` when the drop lands on the "Home" breadcrumb. That always means
 * "the project root", so we canonicalise it to the project's `__root__` folder (`rootFolderId`)
 * — never to the folder the user is currently viewing.
 *
 * This distinction is the whole point: the caller's `effectiveFolderId` (= currentFolderId ??
 * rootFolderId) is the *current* folder when you're inside a subfolder. Resolving Home to that
 * would make the "already there" guards (folder.parent_id === target / file.folder_id === target)
 * treat a drop-onto-Home as a no-op, so dropping a child of the current folder onto Home would
 * silently do nothing instead of moving it up to the root.
 *
 * Returns `null` when `rootFolderId` is unknown; the backend then normalises a null parent/folder
 * to the project root, so the move still lands correctly.
 */
export function resolveDropTarget(
  targetFolderId: string | null,
  rootFolderId: string | null | undefined,
): string | null {
  return targetFolderId ?? rootFolderId ?? null;
}
